module.exports = "pegasus/assets/blocks/column-12-theme3.png";